import getLang from 'I18n/utils/getLang';
import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { na1 } from 'hubspot-url-utils/hublets';
import { getPublicLocalizedPathname } from 'marketplace-ui-common/utils/urls';
export function getRootUrl() {
  return `/marketplace/${PortalIdParser.get()}`;
}
export function getShortlinkUrl() {
  return '/l/marketplace';
}
function getBaseUrl(appContext) {
  return getFullUrl(appContext === 'app' ? 'app' : 'ecosystem', {
    hubletOverride: appContext === 'public' ? na1 : undefined
  });
}
export function getFullMarketplaceUrl(appContext, path, lang) {
  const hrefLang = lang || getLang();
  const baseUrl = getBaseUrl(appContext);
  if (appContext === 'app') {
    return `${baseUrl}/marketplace/${PortalIdParser.get()}${path.replace(/\/+$/, '')}`;
  }
  return `${baseUrl}${getPublicRootUrl(hrefLang)}${path.replace(/\/+$/, '')}`;
}
export function getFullPublicUrl(path, lang) {
  return getFullMarketplaceUrl('public', path, lang);
}
export function getFullAppUrl(path, lang) {
  return getFullMarketplaceUrl('app', path, lang);
}
export function getPublicRootUrl(lang = 'en') {
  return `${getPublicLocalizedPathname(lang)}/marketplace`;
}
export const getTemplateMarketplaceUrl = (appContext, lang) => {
  const baseUrl = getBaseUrl(appContext);
  if (appContext === 'app') {
    return `${baseUrl}/ecosystem/${PortalIdParser.get()}/marketplace/templates`;
  }
  return `${baseUrl}${getPublicRootUrl(lang)}/templates`;
};
export const getSolutionsDirectoryUrl = (appContext, lang) => {
  const baseUrl = getBaseUrl(appContext);
  if (appContext === 'app') {
    return `${baseUrl}/ecosystem/${PortalIdParser.get()}/marketplace/solutions`;
  }
  return `${baseUrl}${getPublicRootUrl(lang)}/solutions`;
};
export const getConnectedAppUrl = appContext => {
  const baseUrl = getBaseUrl(appContext);
  return `${baseUrl}/connected-apps/${PortalIdParser.get()}`;
};
export const getAddedAgentsUrl = appContext => {
  const baseUrl = getBaseUrl(appContext);
  return `${baseUrl}/breeze-studio/${PortalIdParser.get()}/manage-agents/agents`;
};
export const getMarketplaceDownloadsUrl = appContext => {
  const baseUrl = getBaseUrl(appContext);
  return `${baseUrl}/marketplace-settings/${PortalIdParser.get()}/downloads`;
};
export function getWindowLocation() {
  return window.location;
}
export function getListingDetailsShortlink(pathname, params = {}) {
  const queryString = Object.keys(params).length ? `?${new URLSearchParams(params).toString()}` : '';
  return `${getShortlinkUrl()}${pathname}${queryString}`;
}

// forces app url prefix to redirect to login
export function getListingDetailsLoginlink(pathname, params = {}) {
  const baseUrl = getBaseUrl('app');
  const queryString = Object.keys(params).length ? `?${new URLSearchParams(params).toString()}` : '';
  return `${baseUrl}${getShortlinkUrl()}${pathname}${queryString}`;
}
export function stripPortalId(url) {
  const portalId = PortalIdParser.get();
  if (!portalId) {
    return url;
  }
  const portalIdRegex = new RegExp(portalId.toString(), 'g');
  return url.replace(portalIdRegex, '<portal_id>');
}